// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/crosswind.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/crosswind/crosswind.js';

mount([g0]);
